export const AMICA_RESPONSE_DETAIL = 'amica-responsedetail';

export const OUTAGE_CODES = {
  ACCOUNT: 'ACCT001',
  LIFE: 'LIFE001'
};
